import { Link, type Path } from '@report/router';
import {
  Card,
  CardActionArea,
  CardContent,
  DescriptionOutlinedIcon,
  EllipsisText,
  Flex,
  Text,
} from '@shared/components';

export interface ReportMenuCardProps {
  title: string;
  subtitle: string;
  href: Path;
}

export default function ReportMenuCard(props: Readonly<ReportMenuCardProps>) {
  const { title, subtitle, href } = props;

  return (
    <Card
      elevation={0}
      sx={(theme) => ({
        borderRadius: theme.shape.rounded(2),
        border: `1px solid ${theme.palette.grey[300]}`,
        overflow: 'hidden',
      })}
    >
      <CardActionArea component={Link} to={href} sx={{ textDecoration: 'none' }}>
        <CardContent
          sx={(theme) => ({ display: 'flex', p: theme.spacing(4), gap: theme.spacing(4) })}
        >
          <Flex
            sx={(theme) => ({
              p: theme.spacing(2),
              backgroundColor: theme.palette.primary.lighter,
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: theme.shape.rounded(2),
            })}
          >
            <DescriptionOutlinedIcon color='primary' fontSize='large' />
          </Flex>
          <Flex sx={(theme) => ({ gap: theme.spacing(2), flexDirection: 'column' })}>
            <Text variant='h5'>{title}</Text>
            <EllipsisText variant='body2' color='text.secondary'>
              {subtitle}
            </EllipsisText>
          </Flex>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
